import React from "react";

const header = () => {
  return (
    <header>
      <h1>Keeper App</h1>
    </header>
  );
};

export default header;
